<div class="filter">
    <div class="arrow" nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
      <!-- <img src="assets/images/filter.svg" /> -->
      <div>
        <!-- Filter -->
        <nz-badge
          [nzStyle]="{ backgroundColor: '#081A46' }"
          nzShowZero
          [nzCount]="this.totalFilters"
        >
          <img src="../../../assets/icons/filter-icon.svg" />
        </nz-badge>
      </div>
    </div>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <section nz-menu>
        <div class="header">
          <h3>Filters</h3>
        </div>
        <div class="status">
          <span class="pin">
            {{ totalFilters }} filter(s) applied
            <img src="../../../../assets/icons/down-arrow.svg" alt="" />
          </span>
          <a class="clear-all-btn" (click)="clear()">Clear All</a>
        </div>
        <div class="main">
          <div *ngFor="let input of data">
            <nz-collapse
              [nzBordered]="false"
              nzExpandIconPosition="right"
              [nzGhost]="true"
            >
              <nz-collapse-panel
                [nzHeader]="input.label"
                [nzActive]="input.isApplied"
              >
                <div class="input-box full-width">
                  <div
                    *ngIf="input.type == 'select'"
                    class="select-container full-width"
                  >
                    <select
                      class="ng-pristine ng-valid ng-touched"
                      [value]="input.defaultValue"
                      [(ngModel)]="input.value"
                      (change)="onChange($event, input)"
                    >
                      <option
                        *ngFor="let item of input.options"
                        [value]="item.key"
                        [selected]="input.defaultValue === item.key"
                      >
                        {{ item.value }}
                      </option>
                    </select>
                  </div>
                  <input
                    *ngIf="input.type == 'input'"
                    [value]="input.defaultValue"
                    type="text"
                    placeholder="{{ input.placeholder }}"
                    [(ngModel)]="input.value"
                    (change)="onChange($event, input)"
                  />
                  <app-date-range
                    *ngIf="input.type == 'date-range'"
                    (dateChange)="onChange($event, input, 'date')"
                    (fromDateChange)="input.fromDateValue = $event"
                    [fromDate]="input.fromDate"
                    [toDate]="input.toDate"
                    (toDateChange)="input.toDateValue = $event"
                    class="full-width"
                  >
                  </app-date-range>
                </div>
              </nz-collapse-panel>
            </nz-collapse>
            <!-- <label>{{input.label}}</label> -->
          </div>
        </div>
        <!-- <div class="full-width clear">
                  <a (click)="clear()">Clear All</a>
              </div> -->
        <div class="full-width foot">
          <button nz-menu-item (click)="onApplyFiter()" class="btn-primary">
            Apply
          </button>
        </div>
      </section>
    </nz-dropdown-menu>
  </div>
  
